import { dl_insuranceConstants, dealjacketConstants } from "../constants";

const initialState = {
  image_rotations: {}
};

export function dl_insurances(state = initialState, action) {

  switch (action.type) {
    case dl_insuranceConstants.DL_INSURANCE_LIST_REQUEST:
      return {
        isLoading: true,
        image_rotations: state.image_rotations,
      };

    case dl_insuranceConstants.DL_INSURANCE_LIST_SUCCESS:
      return {
        list: action.list,
        image_rotations: state.image_rotations,
      };

    case dl_insuranceConstants.DL_INSURANCE_LIST_FAILURE:
      return {
        error: action.error,
        image_rotations: state.image_rotations,
      };

    case dl_insuranceConstants.DL_INSURANCE_ASSIGN_DEAL_NUMBER_REQUEST:
      return state;

    case dl_insuranceConstants.DL_INSURANCE_ASSIGN_DEAL_NUMBER_SUCCESS:
      return state;

    case dl_insuranceConstants.DL_INSURANCE_ASSIGN_DEAL_NUMBER_FAILURE:
      return state;

    case "rotate_dl_insurance_image":
      return {
        ...state,
        image_rotations: {...state.image_rotations, [action.page_id]: action.rotation},
      }

    case dl_insuranceConstants.DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_SUCCESS:

      return {
        ...state,
        list: action.list,
        deal_jacket_with_identity_documents: action.receiving_deal_jacket,
        last_added_identity_document_packet: action.identity_jacket, // TODO: consider scope of history
        deal_jacket_to_add_to: undefined,
        current_submission_selected: undefined,
        deal_number_input_entry: undefined,
        deal_jacket_created_result: undefined,
        dl_insurance_processing_state: false,
      }

    case "dl_insurance_processing_state":
      return {
        ...state,
        dl_insurance_processing_state: true
      }

    case "update_dl_insurance_list_after_identity_assignment":
      return {
        ...state,
        list: action.list
      }

    case dl_insuranceConstants.DL_INSURANCE_CLEAR_DEAL_JACKET_SUCCESS:

      return {
        ...state,
        deal_jacket_with_identity_documents: undefined,
        deal_jacket_to_add_to: undefined,
        deal_jacket_created_result: undefined,
        dl_insurance_processing_state: undefined,
      }

    /* NOTE: handling retained state with different pattern than previously using ...spread. */

    case dl_insuranceConstants.DL_INSURANCE_SELECT_SUBMISSION:
      return { ...state,
        current_submission_selected: action.deal_jacket,
        alert_message: undefined,
        alert_type: undefined,
      };

    case dl_insuranceConstants.DL_INSURANCE_UPDATE_DEAL_NUMBER_INPUT_FIELD:
      return { ...state,
        deal_number_input_entry: action.deal_number_entry
      };

    case dl_insuranceConstants.DL_INSURANCE_NO_MATCHING_JACKET_FOUND:
      return { ...state,
        check_deal_number_response: dl_insuranceConstants.DL_INSURANCE_NO_MATCH
      };

    case dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_SUCCESS:
      return {
        ...state,
        check_deal_number_response: undefined,
        jackets_matching_requested_number: action.list,
        deal_jacket_to_add_to: action.list[0] // TODO actually check in the action.
      }

    case dl_insuranceConstants.DL_INSURANCE_CLEAR_DEAL_NUMBER_REQUEST:
      return {
        ...state,
        jackets_matching_requested_number: undefined,
        deal_jacket_created_result: undefined,
        deal_jacket_to_add_to: undefined,
        //deal_jacket_with_identity_documents: undefined,
      }

    case dl_insuranceConstants.DL_INSURANCE_CREATE_JACKET_FROM_DEAL_NUMBER_SUCCESS:
      return {
        ...state,
        deal_jacket_created_result: action.deal_jacket,
        deal_jacket_to_add_to: action.deal_jacket,
      }

    case dl_insuranceConstants.DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_FAILURE:
      return {
        ...state,
        dl_insurance_processing_state: undefined
      }

    case dl_insuranceConstants.DL_INSURANCE_DISPLAY_ALERT_MESSAGE:
      return {
        ...state,
        alert_message: action.alert_message,
        alert_type: action.alert_type,
      }

    default: {
      return state;
    }
  }
}
